import { useState, useEffect, useRef } from "react";
import { getPageStats } from "../services/facebookService";

const POLL_MS = 60 * 1000;

/**
 * Polls the backend Facebook stats endpoint every 60 seconds.
 * Tokens are managed server-side — never passed from the browser.
 * Returns { configured, loading, followersCount, followingCount, postsCount, error }.
 */
export function useFacebookStats(pageId) {
  const [state, setState] = useState({ configured: false, loading: !!pageId, isLive: null });
  const mountedRef = useRef(true);

  useEffect(() => {
    mountedRef.current = true;
    return () => { mountedRef.current = false; };
  }, []);

  useEffect(() => {
    if (!pageId) {
      setState({ configured: false, loading: false });
      return;
    }

    async function poll() {
      try {
        const stats = await getPageStats(pageId);
        if (!mountedRef.current) return;
        setState({ configured: true, loading: false, ...stats });
      } catch (err) {
        if (!mountedRef.current) return;
        setState(prev => ({ ...prev, configured: false, loading: false, error: err.message }));
      }
    }

    poll();
    const timer = setInterval(poll, POLL_MS);
    return () => clearInterval(timer);
  }, [pageId]);

  return state;
}
